import cn from 'classnames';
import { ButtonHTMLAttributes, MouseEvent } from 'react';

import styles from './Button.module.scss';

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  id?: string;
  color?: string;
  className?: string;
  variant?: string;
  text: string;
  disabled?: boolean;
  endArrow?: boolean;
  type?: 'submit' | 'reset' | 'button';
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

const Button = ({
  id,
  color = 'default',
  className = '',
  variant = 'contained',
  text,
  disabled,
  endArrow,
  ...rest
}: IButtonProps) => {
  const colorClassName = `Button${color.charAt(0).toUpperCase()}${color.slice(1)}`;
  let classNames = cn([
    styles.Button,
    styles[colorClassName],
    className,
    colorClassName,
    {
      [styles.ButtonContained]: variant === 'contained',
      [styles.ButtonDisabled]: disabled,
    },
  ]);

  if (endArrow) {
    classNames = cn([classNames, styles.ButtonWithCaret]);
  }

  return (
    <>
      <button className={classNames} disabled={disabled} id={id} {...rest}>
        {text}
        {endArrow && <span className={styles.Caret} />}
      </button>
    </>
  );
};

export { Button };
